import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "row",
  role: "tabpanel"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex flex-row mx-auto" }
const _hoisted_4 = { class: "flex flex-col flex-auto min-w-0 mb-8" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "d-none d-lg-block symbol symbol-60px symbol-circle me-7" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "symbol-label bg-primary text-inverse-warning fw-bolder fs-1"
}
const _hoisted_9 = { class: "min-w-0 ml-4" }
const _hoisted_10 = { class: "fw-bolder fs-1" }
const _hoisted_11 = { class: "d-none d-lg-flex items-center" }
const _hoisted_12 = { class: "ml-2 fs-6 fw-lighter" }
const _hoisted_13 = { class: "ms-auto" }
const _hoisted_14 = {
  key: 0,
  class: "d-none d-lg-block col-lg-2"
}
const _hoisted_15 = { class: "card mb-5 mb-xl-8" }
const _hoisted_16 = { class: "card-body pt-15" }
const _hoisted_17 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_18 = { class: "symbol symbol-100px symbol-circle mb-7" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "symbol-label bg-primary text-inverse-warning fw-bolder fs-1"
}
const _hoisted_21 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}
const _hoisted_22 = { class: "fs-5 fw-bold text-muted mb-6 text-center" }
const _hoisted_23 = { class: "d-flex flex-stack fs-4 py-3 justify-content-center" }
const _hoisted_24 = {
  class: "fw-bolder rotate collapsible collapsed text-center",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#invitation_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_user_view_details"
}
const _hoisted_25 = { class: "ms-2 rotate-180" }
const _hoisted_26 = {
  id: "invitation_details",
  class: "collapse",
  style: {}
}
const _hoisted_27 = { class: "py-2" }
const _hoisted_28 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_29 = {
  href: "#",
  class: "fs-5 text-dark text-hover-primary fw-bolder"
}
const _hoisted_30 = { class: "fs-6 fw-bold text-muted" }
const _hoisted_31 = { class: "d-flex justify-content-center mt-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = {
  "element-loading-text": "Loading Schedule",
  class: "card mb-5 mb-xl-10"
}
const _hoisted_35 = { class: "card-header mt-4" }
const _hoisted_36 = { class: "card-title flex-column" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "My Schedule", -1)
const _hoisted_38 = { class: "fs-6 fw-bold text-muted" }
const _hoisted_39 = { class: "card-toolbar" }
const _hoisted_40 = { class: "card-body p-0" }
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = {
  "element-loading-text": "Checking for recent communications",
  class: "card mb-5 mb-xl-10"
}
const _hoisted_43 = { class: "card-header mt-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "card-title flex-column" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "Communications"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-muted" }, "showing last seven days")
], -1)
const _hoisted_45 = { class: "card-toolbar" }
const _hoisted_46 = { class: "my-1 me-4 d-none" }
const _hoisted_47 = { class: "card-body p-0" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-bullhorn fa-4x" }, null, -1)
const _hoisted_49 = {
  key: 1,
  class: "d-flex flex-column mb-6 mt-4 px-4 mx-6"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "d-flex flex-column" }
const _hoisted_52 = {
  class: "fs-3 fw-bolder text-white text-truncate",
  style: {"text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_53 = {
  key: 0,
  class: "fs-7"
}
const _hoisted_54 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_55 = { class: "fs-5 text-gray-800 fst-italic" }
const _hoisted_56 = { class: "fs-6 text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddPhoneAlert = _resolveComponent("AddPhoneAlert")!
  const _component_NewInivitationAlert = _resolveComponent("NewInivitationAlert")!
  const _component_OnboardingTab = _resolveComponent("OnboardingTab")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AngleDown = _resolveComponent("AngleDown")!
  const _component_ScheduleWidget = _resolveComponent("ScheduleWidget")!
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.userStore.hasAccessToEntities && _ctx.userStore.fetchComplete)
      ? (_openBlock(), _createBlock(_component_AddPhoneAlert, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.userStore.fetchComplete)
      ? (_openBlock(), _createBlock(_component_NewInivitationAlert, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.userStore.hasAccessToEntities && _ctx.userStore.fetchComplete)
      ? (_openBlock(), _createBlock(_component_OnboardingTab, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.userStore.hasAccessToEntities)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.userStore.profile.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.userStore.profile.avatar,
                          alt: "image"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.userStore.profile.firstName[0]) + _toDisplayString(_ctx.userStore.profile.lastName[0]), 1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.greeting) + ", " + _toDisplayString(_ctx.userStore.profile.firstName) + "! ", 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, "You have " + _toDisplayString(_ctx.recentCommunications.length !== 0 ? _ctx.recentCommunications.length : 'no') + " recent communications and " + _toDisplayString(_ctx.calls.length !== 0 ? _ctx.calls.length : 'no') + " upcoming calls ", 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  onClick: _ctx.goToSettings,
                  type: "light-primary",
                  class: "d-none d-lg-block text-white me-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Manage Profile ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", null, [
                (_ctx.userStore.invitations.length === 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      onClick: _ctx.toggleRequestAccess,
                      type: "light-primary",
                      class: "d-none d-lg-block text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Request Access ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.userStore.profile.avatar)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.userStore.profile.avatar,
                              alt: "image"
                            }, null, 8, _hoisted_19))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.userStore.profile.firstName[0]) + _toDisplayString(_ctx.userStore.profile.lastName[0]), 1))
                      ]),
                      _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.userStore.profile.firstName) + " " + _toDisplayString(_ctx.userStore.profile.lastName), 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.userStore.profile.title), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleRequestAccess && _ctx.toggleRequestAccess(...args))),
                        class: "btn btn-sm btn-flex text-white btn-light-primary"
                      }, " Request Access ")
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createTextVNode("Invitations "),
                        _createElementVNode("span", _hoisted_25, [
                          _createVNode(_component_AngleDown)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStore.invitations, (invitation) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: invitation.entityName
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("a", _hoisted_29, _toDisplayString(invitation.entityName), 1),
                              _createElementVNode("div", _hoisted_30, _toDisplayString(invitation.title), 1),
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_Button, {
                                  onClick: ($event: any) => (_ctx.viewInvitation(invitation)),
                                  class: "btn btn-sm btn-flex text-white btn-light-primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("View Details ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _hoisted_32
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.calls.length !== 0 ? _ctx.calls.length : 'No') + " upcoming calls", 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-sm text-white d-none d-md-block",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.invokeAddConflict && _ctx.invokeAddConflict(...args)))
                  }, " Add Conflict "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-sm text-white d-md-none",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToManageConflicts && _ctx.navigateToManageConflicts(...args)))
                  }, " Manage Conflicts ")
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_ScheduleWidget, { schedule: _ctx.calls }, null, 8, ["schedule"])
              ])
            ])), [
              [_directive_loading, _ctx.scheduleLoading]
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_Selector2, {
                      modelValue: _ctx.communicationsFilter,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.communicationsFilter) = $event)),
                      class: "form-select-sm form-select-solid",
                      options: ['Last 7 Days', 'This Week', 'Today']
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_Button, {
                    class: "btn-sm",
                    onClick: _ctx.navigateToCommunications
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View All")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_ctx.recentCommunications.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "No communications in the last 7 days"
                    }, {
                      image: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentCommunications, (communication) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "d-flex flex-column cursor-pointer mb-4",
                          key: communication.communicationId,
                          onClick: ($event: any) => (_ctx.viewCommunication(communication)),
                          style: {"width":"100%"}
                        }, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, _toDisplayString(communication.title), 1),
                            (communication.authorFirstName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, " posted by " + _toDisplayString(communication.authorFirstName) + " " + _toDisplayString(communication.authorLastName), 1))
                              : _createCommentVNode("", true)
                          ]),
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, _toDisplayString(communication.entityName), 1),
                                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.getRelativeDateTime(communication.lastUpdated)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_50))
                      }), 128))
                    ]))
              ])
            ])), [
              [_directive_loading, _ctx.communicationsLoading]
            ])
          ])
        ])), [
          [_directive_loading, !_ctx.userStore.fetchComplete]
        ])
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, !_ctx.userStore.fetchComplete]
  ])
}